module.exports = __webpack_public_path__ + "img/xyw.38a513a5.png";